module.exports = {"410171111":"九龙镇","410171560":"经济开发区明湖街道","410171561":"经济开发区潮河街道","410171562":"京航街道","410171563":"前程","410171565":"祥云"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410171.json
// module id = 1520
// module chunks = 0